// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".expiry-warning{color:rgba(0,0,0,0.87);background-color:#de8787 !important}\n", ""]);
// Exports
module.exports = exports;
